export default "__VITE_ASSET__B2B2V8xF__"